"use strict";

exports.__esModule = true;
exports.AsyncBaseComponent = void 0;
var _react = require("react");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Base component to handle issues with async requests in
 * React components
 */
var AsyncBaseComponent = exports.AsyncBaseComponent = /*#__PURE__*/function (_Component) {
  function AsyncBaseComponent() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.mounted = false;
    return _this;
  }
  _inheritsLoose(AsyncBaseComponent, _Component);
  var _proto = AsyncBaseComponent.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  _proto.setState = function setState(state, callback) {
    if (!this.mounted) {
      return;
    }
    return _Component.prototype.setState.call(this, state, callback);
  };
  return AsyncBaseComponent;
}(_react.Component);